var map = {
	"./dark/AllCategories.svg": 4875,
	"./dark/Beer.svg": 9179,
	"./dark/CarrierBag.svg": 1234,
	"./dark/FoodToGo.svg": 938,
	"./dark/Fruit.svg": 562,
	"./dark/GreetingsCards.svg": 2364,
	"./dark/HotDrinks.svg": 5882,
	"./dark/Lottery.svg": 538,
	"./dark/Miscellaneous.svg": 1069,
	"./dark/Newspaper.svg": 4270,
	"./dark/NoChosenCategory.svg": 8816,
	"./dark/SlushyDrinks.svg": 5773,
	"./dark/Stamps.svg": 7875,
	"./dark/Vegetables.svg": 2901,
	"./light/AllCategories.svg": 2299,
	"./light/Beer.svg": 2876,
	"./light/CarrierBag.svg": 4061,
	"./light/FoodToGo.svg": 9192,
	"./light/Fruit.svg": 4070,
	"./light/GreetingsCards.svg": 1690,
	"./light/HotDrinks.svg": 5168,
	"./light/Lottery.svg": 8066,
	"./light/Miscellaneous.svg": 312,
	"./light/Newspaper.svg": 7541,
	"./light/NoChosenCategory.svg": 5043,
	"./light/SlushyDrinks.svg": 5251,
	"./light/Stamps.svg": 2038,
	"./light/Vegetables.svg": 8556
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8696;